<app-dialog [visible]="true" [closable]="true" cssClass="dialog-lg">
  <div class="header">
    <div class="row space-between">
      <h3>Support</h3>

      <button mat-stroked-button (click)="openLicenceFile()">Third party notice</button>
    </div>
  </div>
  <div class="body">
    <div class="field-subtitle">
      <div i18n>
        To report a technical issue with the Restricted Product website, click here to 
          <a
            target="new"
            (click)="openSupportTicketModal()"
            >submit a ticket.</a
          >
        <div class="margin top">
          To check the status of your key system order, <a href="https://360portal.allegion.com/">click here</a> to use the Order Status tool in our
          <strong> 360 Portal.</strong>
        </div>
        <div class="margin top">
          To ask questions about your key system order, contact Key Control at
          <a href="mailto:KeyControlDepartment@allegion.com">KeyControlDepartment&#64;allegion.com</a>.
        </div>
      </div>
    </div>
    <div class="field-subtitle">
      <p i18n>
        Once this account is active, <strong>only the electronic face sheet will be accepted</strong> as a means of
        authorizing an Allegion authorized distributor to purchase restricted products on my behalf.
        <strong>Letters of Authorization and Primus Face Sheets will no longer be accepted</strong> as a means to
        authorize purchases for restricted products for the restricted key systems assigned to my user account.
      </p>
    </div>
  </div>
  <div class="footer">
    <app-button cssClass="primary btn-sm" (buttonClick)="dialogService.close()" i18n>Ok</app-button>
  </div>
</app-dialog>
